import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import { parseToastTranslationKey, NOTIFY_TOASTR_OPTIONS } from "./constants";
import toastr from "toastr";
import Amplitude from "./amplitude";
import { postAccountsApi, headCacheCheck } from "./ajax";
import SessionIdleTemplate from "@Shared/@HandlebarsTemplates/general/_session-idle.hbs";
import NewVersionTemplate from "@Shared/@HandlebarsTemplates/general/_new-web-version.hbs";
import i18n from "@Shared/@i18n";
import moment from "moment";
export default class Session {
  constructor(vm) {
    _defineProperty(this, "$vm", void 0);
    _defineProperty(this, "renewing", void 0);
    _defineProperty(this, "checkingVersion", void 0);
    _defineProperty(this, "isOnPages", pages => _includesInstanceProperty(pages).call(pages, location.hash.split("?")[0]));
    _defineProperty(this, "checkCache", async () => {
      if (!this.sessionToken) return;
      const CACHE_KEY = "lastCacheCheck";
      const lastCheck = this.get()[CACHE_KEY];
      if (!lastCheck) {
        this.store.commit("AccountStore/SET_LAST_CACHE_CHECK", moment().valueOf());
        return;
      }
      const diff = moment().diff(moment(_parseInt(lastCheck)), "seconds") || 0;
      const shouldCheckCache = !this.checkingVersion && diff > Session.CACHE_INTERVAL;
      if (shouldCheckCache) {
        this.store.commit("AccountStore/SET_LAST_CACHE_CHECK", moment().valueOf());
        const allScripts = [..._Array$from(document.scripts)];
        const ourBundleRegex = /.+main\..+.js/;
        const bundleScript = _findInstanceProperty(allScripts).call(allScripts, script => script.src.match(ourBundleRegex));
        if (bundleScript) {
          try {
            this.checkingVersion = true;
            await headCacheCheck(bundleScript.src);
          } catch (e) {
            if (e.status == 404) {
              this.notifyNewVersion();
            }
          } finally {
            this.checkingVersion = false;
          }
        }
      }
    });
    _defineProperty(this, "checkSession", async () => {
      if (!this.sessionToken) return;
      const {
        idleTime
      } = window;
      const {
        expiration
      } = this.get();
      const expirationTime = moment(expiration);
      const now = moment();
      const difference = expirationTime.diff(now, "seconds");
      if (!expiration) {
        Amplitude.logEvent("Session ended due to invalid expiration");
        return this.end();
      }
      if (difference <= 0) {
        Amplitude.logEvent("Session ended due to expiration");
        return this.end();
      }
      if (!this.renewing && difference <= Session.EXPIRATION_DIFFERENCE && idleTime < Session.IDLE_TIME_EXPIRE) {
        this.renewing = true;
        this.renew().then(() => {
          this.renewing = false;
          Amplitude.logEvent("Session extended");
        });
      }
    });
    _defineProperty(this, "checkIdleTime", () => {
      if (!this.sessionToken) {
        Amplitude.logEvent("Session ended due to abrupt lost of token");
        return this.end();
      }
      window.idleTime++;
      if (window.idleTime >= Session.IDLE_TIME_NOTIFICATION) this.notifyIdle();
      if (window.idleTime >= Session.IDLE_TIME_EXPIRE) {
        Amplitude.logEvent(`Session ended due to idle time with idle time: ${window.idleTime} seconds`);
        return this.end();
      }
    });
    _defineProperty(this, "resetTimer", () => {
      window.idleTime = 0;
    });
    _defineProperty(this, "startIdleCheck", () => {
      this.resetTimer();
      $(document).off("noidle");
      $(document).on("noidle", this.resetTimer);
      return setInterval(this.checkIdleTime, 1000);
    });
    this.$vm = vm;
    this.renewing = false;
    this.checkingVersion = false;
  }
  get store() {
    return this.$vm.$store;
  }
  get sessionStore() {
    return this.$vm.$store.state.AccountStore;
  }
  get sessionToken() {
    return this.sessionStore.token || null;
  }
  get() {
    return this.sessionStore;
  }
  end() {
    this.store.dispatch("AccountStore/END_SESSION");
  }
  initFreshChat() {
    try {
      const {
        userDetails: {
          username,
          givenName,
          familyName,
          email
        },
        accountDetails: {
          accountPlan,
          accountStatus,
          accountSubdomain,
          accountType,
          expirationDate,
          timezone
        }
      } = this.get();
      window.fcWidget.setExternalId(username);
      window.fcWidget.user.setProperties({
        email,
        firstName: givenName,
        lastName: familyName,
        accountPlan,
        accountStatus,
        accountSubdomain,
        accountType,
        timezone,
        expirationDate: moment(expirationDate).format("LL")
      });
    } catch (error) {
      console.error(error);
      Amplitude.logHandledError(error, {}, "Fresh chat init failed");
    }
  }
  notifyIdle() {
    if ($("#expired-screen").is(":visible") || $("#idle-toast").is(":visible")) return;
    toastr.info(SessionIdleTemplate({
      youveBeenIdleForAWhile: parseToastTranslationKey("youveBeenIdleForAWhile"),
      no: i18n.t("global.words.no"),
      yesLogMeOut: parseToastTranslationKey("yesLogMeOut")
    }), parseToastTranslationKey("idleTimeDetected"), NOTIFY_TOASTR_OPTIONS);
    $("#logout", "#idle-toast").one("click", () => this.end());
  }
  notifyNewVersion() {
    if ($("#expired-screen").is(":visible") || $("#new-version-toast").is(":visible")) return;
    toastr.info(NewVersionTemplate({
      pageReloadIsRequired: parseToastTranslationKey("pageReloadIsRequired"),
      no: i18n.t("global.words.no"),
      yesReloadSite: parseToastTranslationKey("yesReloadSite")
    }), parseToastTranslationKey("newUpdated"), NOTIFY_TOASTR_OPTIONS);
    $("#get-me-out", "#new-version-toast").one("click", () => window.location.reload());
  }
  async renew() {
    try {
      const session = this.get();
      const data = {
        token: this.sessionToken,
        id: session.xData.id,
        ref: session.xData.ref
      };
      const config = JSON.parse(localStorage.getItem("deviceInfo") || "{}");
      if (config["deviceInfo"]) {
        data["deviceInfo"] = config["deviceInfo"];
      }
      const res = await postAccountsApi(data, "/token");
      this.store.dispatch("AccountStore/INIT_SESSION", res);
      this.$vm.$socket.reconnect(res.token);
    } catch (e) {
      Amplitude.logHandledError(e);
    }
  }
  startChecking() {
    this.checkCache();
    this.checkSession();
    return setInterval(() => {
      this.checkSession();
      this.checkCache();
    }, Session.CHECK_INTERVAL);
  }
}
_defineProperty(Session, "CACHE_INTERVAL", 5 * 60);
_defineProperty(Session, "IDLE_TIME_NOTIFICATION", 15 * 60);
_defineProperty(Session, "IDLE_TIME_EXPIRE", 4 * 60 * 60);
_defineProperty(Session, "CHECK_INTERVAL", 5000);
_defineProperty(Session, "EXPIRATION_DIFFERENCE", 10 * 60);
_defineProperty(Session, "ignoreErrorBroadcast", false);